<template>
  <div class="base-content">
    <query-frame
      :current="page.current"
      :total="page.total"
      @on-query="handleQuery"
      @on-reset="handleReset"
      @on-add="handleAdd"
      @on-page-change="handlePageChange"
      @on-size-change="handleSizeChange"
    >
      <!-- 查询条件开始 -->
      <template slot="query">
        <query-item label="门店名称">
          <a-input v-model="query.storeName" placeholder="门店名称"></a-input>
        </query-item>
        <query-item label="门店负责人">
          <a-input v-model="query.name" placeholder="门店负责人"></a-input>
        </query-item>
        <query-item label="状态">
          <a-select v-model="query.status" >
            <a-select-option :value="1">
              启用
            </a-select-option>
            <a-select-option :value="2">
              禁用
            </a-select-option>
          </a-select>
        </query-item>

      </template>
      <!-- 查询条件结束 -->

      <!-- 查询结果 开始 -->
      <template slot="table">
        <i-table :columns="columns" :dataSource="dataList">
        </i-table>
      </template>
      <!-- 查询结果 结束 -->
    </query-frame>
  </div>
</template>

<script>
import { storeList } from '@/api/store';
import queryMixin from '@/mixin/queryMixin';

export default {
  name: 'storeList',
  mixins: [queryMixin],
  components: {
  },
  props: {},
  data() {
    return {
      query: {
        storeName: null,
        name: null,
        status: null,
      },
      // 默认展示表格
      columns: [
        {
          title: '序号',
          ellipsis: true,
          width: 80,
          customRender(text, item, index) {
            return index + 1;
          }
        },
        {
          title: '门店编号',
          dataIndex: 'code',
          key: 'code',
          ellipsis: true,
          width: 200,
        },
        {
          title: '门店名称',
          dataIndex: 'storeName',
          key: 'storeName',
          ellipsis: true,
          width: 200,
        },
        // 门店编号、门店名称、门店负责人、电话、地址、备注、创建时间、创建人、状态
        {
          title: '门店负责人',
          dataIndex: 'bossName',
          key: 'bossName',
          ellipsis: true,
        },
        {
          title: '电话',
          dataIndex: 'phone',
          key: 'phone',
          ellipsis: true,
        },
        {
          title: '地址',
          dataIndex: 'address',
          key: 'address',
          ellipsis: true,
        },
        {
          title: '备注',
          dataIndex: 'remark',
          key: 'remark',
          ellipsis: true,
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          key: 'createTime',
          ellipsis: true,
          width: 160,
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          width: 120,
          customRender: (text, row, index) => {
            return (
              <a-switch checked-children="启用" un-checked-children="禁用" default-checked />
            );
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 220,
          scopedSlots: { customRender: 'action' },
          customRender: (text, row) => {
            return {
              children: <section>
                <a-button type="link" size="small" onClick={ () => this.handleInfo(row) }>查看</a-button>
                <a-divider type="vertical"></a-divider>
                <a-button type="link" size="small" onClick={ () => this.handleEdit(row) }>修改</a-button>
              </section>,
            }
          }
        },
      ],
      dataList: []
    };
  },
  computed: {},
  watch: {},
  created() {
    this.handleQuery();
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
    // 获取列表
    getData() {
      const params = {
        page: this.page.current,
        size: this.page.pageSize,
        name: 'leo',
        age: 30,
      };
      storeList(params).then((data) => {
        this.dataList = data;
      });
    },

    // 添加
    handleAdd() {
      this.$router.push({
        name: 'storeAdd'
      });
    },

    handleInfo(row) {
      this.$router.push({
        name: 'storeInfo',
        params: {
          id: row.id
        }
      });
    },
    // 编辑
    handleEdit(row) {
      this.$router.push({
        name: 'storeEdit',
        params: {
          id: row.id
        }
      });
    },
  }
};
</script>

<style lang="less" scoped>

</style>
